import React, {useEffect, useState} from "react";
import {
  Form,
  Row,
  Col,
  Space,
  DatePicker,
  Input,
  Button,
  Spin,
  message,
} from "antd";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {InputFields} from "components/common";
import {employeeService} from "api";
import Notification from "../../../../../../components/common/notification/notification";
import dayjs from "dayjs";
import {RangePickerProps} from "antd/es/date-picker";
import {getListMDK, searchEmployeeAPI} from "redux/reducer/employee";
import {items} from "layout/main-layout/header/config";
import {DataFormField} from "types/models/input-field-type";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {fi} from "date-fns/locale";
const {
  INPUT,
  DATE,
  DATE_DISABLE_NO_DAY,
  COMBO_BOX,
  SELECT,
  AUTO_COMPLETE,
  CURRENCY,
  NUMBER,
  DATE_PRE,
  DATE_ON,
  DATE_DISABLE,
} = FIELD_TYPE;
const FormAdd = props => {
  const {data, datas, closeModal, type, getListApi, setCurrentPage} = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [code, setCode] = useState(null);
  const employees = useAppSelector(state => state.employeesReducer);
  //   useEffect(() => {
  //     const disabledDateStart: RangePickerProps["disabledDate"] = currentDate => {
  //       const endDay = form.getFieldValue("thoiGianApDungDen");
  //       if (endDay) {
  //         return currentDate > endDay;
  //       }
  //     };
  //     const disabledDateEnd: RangePickerProps["disabledDate"] = currentDate => {
  //       const start = form.getFieldValue("thoiGianApDungTu");
  //       if (start) {
  //         return currentDate < start;
  //       }
  //     };
  //     inputFieldsInit.find(e => e.name == "thoiGianApDungTu").disabledDate = disabledDateStart;
  //     inputFieldsInit.find(e => e.name == "thoiGianApDungDen").disabledDate = disabledDateEnd;
  //     setFieldInfo([...inputFieldsInit]);
  //   }, []);
  const onChangeMDK = async e => {
    try {
      const res = await employeeService.getResgister([e]);
      if (res && Array.isArray(res)) {
        let selectedObject;
        for (let item of res) {
          if (item.tenLoaiNghiPhep === e) {
            selectedObject = item;
            break;
          }
        }
        if (selectedObject !== undefined) {
          let name = selectedObject.maDangKyNghi;
          form.setFieldValue("maDangKy", name);
        } else {
          // console.log("Không tìm thấy dữ liệu cho tên nhân viên đã chọn");
        }
      } else {
        //  console.log("Dữ liệu không hợp lệ hoặc không có dữ liệu");
      }
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
    }
  };

  const dataFields: DataFormField[] = [
    {
      type: COMBO_BOX,
      label: "Tên nhân viên",
      name: "maNV",
      disable: false,
      css: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
      // options: idDK,
      labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
      wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},
      disableDate: false,
      rules: [{required: true, message: "Chưa chọn nhân viên"}],
    },
    {
      type: COMBO_BOX,
      label: "Loại nghỉ phép",
      name: "loaiNghiPhep",
      disable: false,
      css: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
      wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},
      //  options: list,
      onChange: onChangeMDK,
      rules: [{required: true, message: "Chưa chọn loại nghỉ phép"}],
    },
    {
      type: DATE,
      label: "Ngày đăng ký",
      name: "ngayDangKy",
      disable: false,
      css: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
      wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},
      disableDate: false,
      optionsTime: {showTime: true, format: FORMAT_TIME.dateTime},
      rules: [{required: true, message: "Chưa nhập ngày đăng ký"}],
    },
    {
      type: INPUT,
      label: "Mã đăng ký",
      name: "maDangKy",
      disable: true,
      css: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
      //  options: idDK,
      labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
      wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},
      disableDate: true,
      // rules: [{ required: true, message: "Chưa nhập mã đăng ký" }],
    },
    {
      type: INPUT,
      label: "Lý do",
      name: "lyDo",
      css: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: {xs: 10, md: 8, lg: 4, xl: 3},
      wrapperCol: {xs: 14, md: 16, lg: 20, xl: 21},
      disable: false,
    },
  ];
  const [fieldInfo, setFieldInfo] = useState(dataFields);
  const dispatch = useAppDispatch();
  useEffect(() => {
    setLoading(true);
    if (type == "Thêm") {
      // newId();
      setLoading(false);
      form.resetFields();
      //  form.setFieldValue("maCauHinh",code);
    } else {
      setLoading(false);
      form.setFieldsValue(data);
    }
  }, [data, code]);
  //   const newId = async () => {
  //     try {
  //       const res = await employeeService.getNewIdCauHinhLuong();
  //       setCode(res);
  //     } catch (error) {
  //       Notification("error", "Đã có lỗi khi lấy mã cấu hình lương");
  //     }
  //   };
  useEffect(() => {
    dispatch(
      searchEmployeeAPI({
        page: 1,
        limit: 1000,
      })
    );
  }, []);
  useEffect(() => {
    dispatch(
      getListMDK({
        page: 1,
        limit: 1000,
      })
    );
  }, []);
  useEffect(() => {
    setOptionsKLFields(employees.employeesList, "maNV");
    //console.log("bbbbb",employees.employeesList);
    // onClickSearch();
  }, [employees.employeesList]);
  useEffect(() => {
    setOptionsMDKFields(employees.maDK, "loaiNghiPhep");
    // console.log("aaaa", employees.maDK);
  }, [employees.maDK]);
  const setOptionsKLFields = (list, danhmuc) => {
    if (fieldInfo.find(field => field.name === danhmuc)) {
      fieldInfo.find(field => field.name === danhmuc).options = list?.map(
        item => ({
          value: item.maNhanVien,
          label: item.hoTen,
        })
      );
      setFieldInfo([...fieldInfo]);
    }
  };
  const setOptionsMDKFields = (list, tenLoai) => {
    if (fieldInfo.find(field => field.name === tenLoai)) {
      fieldInfo.find(field => field.name === tenLoai).options = list?.map(
        item => ({
          value: item.tenLoaiNghiPhep,
          label: item.tenLoaiNghiPhep,
          key: `${item.id}`,
        })
      );
      setFieldInfo([...fieldInfo]);
    }
  };
  // console.log("ấdasdasd",roles);

  const addApi = async () => {
    setLoading(true);
    console.log("data", data);

    try {
      const params = {
        ...form.getFieldsValue(), // Lấy giá trị từ form
        //  idNhanVien: datas.idNhanVien,
        // usernameDangKy:datas.usernameDangKy,
        //  userQuyenDangKy:data.userQuyenDangKy,
      };
      await employeeService.updateRegister(params).then(res => {
        if (res.code === 400) {
          Notification("error", res.message);
        } else {
          Notification("success", "Đã thêm mới đăng ký nghỉ phép thành công");
        }
      });
      closeModal();
      await getListApi({});
      setLoading(false);
      // newId();
      form.resetFields();
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi thêm mới đăng ký nghỉ phép");
    }
  };
  const editApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
        id: data.id, // Lấy giá trị từ form
        //  idNhanVien: datas.idNhanVien,
        // usernameDangKy:datas.usernameDangKy,
        // userQuyenDangKy:data.userQuyenDangKy,
      };
      await employeeService.updateRegister(params).then(res => {
        if (res.code === 400) {
          Notification("error", res.message);
        } else {
          Notification("success", "Đã sửa đăng ký nghỉ phép thành công");
        }
      });

      setLoading(false);
      closeModal();
      await getListApi({});
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi sửa đăng ký nghỉ phép");
    }
  };
  useEffect(() => {
    form.setFieldsValue({
      ...data,
      ngayDangKy: data?.ngayDangKy ? dayjs(data.ngayDangKy) : null,
    });
  }, [data]);
  const onFinish = values => {
    if (type == "Thêm") {
      addApi();
    } else {
      editApi();
    }
  };

  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[16, 8]}>
              <InputFields data={fieldInfo}></InputFields>
            </Row>
            <Row justify="end">
              <Col>
                <Space>
                  <Button
                    onClick={closeModal}
                    style={{
                      backgroundColor: "red",
                      borderColor: "red",
                      color: "white",
                    }}
                  >
                    Hủy bỏ
                  </Button>
                  <Button htmlType="submit" type="primary">
                    Lưu lại
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default FormAdd;
